import type { Lobby } from '@archon3d/core';

/**
 * A lobby's changes leave an editor game's definition out: it came once, with `created` or
 * `joined` (net-server:quality#10), and the lobby keeps it.
 */
export function keepDefinition(previous: Lobby, next: Lobby): Lobby {
  const definition = previous.setup.definition;
  if (next.setup.definition || !definition || next.setup.boardId !== previous.setup.boardId)
    return next;
  return { ...next, setup: { ...next.setup, definition } };
}
